<template>
  <PageLayout>
    <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-2">
      Propojení Adveroo s Facebookem
    </h2>
    <p class="body-2 navy--text text--darken-1 pb-10">
      Propojte Adveroo se svým Facebook účtem
    </p>

    <v-alert class="mb-12" outlined type="info" icon="mdi-information-outline">
      <div>
        Aplikace Adveoo potřebuje pro práci s reklamami a okruhy uživatelů
        povolit práva pro přístup. Po kliknutí na tlačítko budete přesměrováni
        na Facebook, kde po přihlášení k Vašemu Facebook účtu bude potřeba tato
        práva pro aplikaci Adveroo povolit.
      </div>
    </v-alert>

    <div class="text-center">
      <v-btn
        color="facebook"
        dark
        :loading="fbLoginPending"
        @click="redirectToFacebook"
      >
        <v-icon left>mdi-facebook</v-icon> Propojit Facebook
      </v-btn>
    </div>
    <div class="text-center">
      <iframe
        class="mt-5 mx-auto text-center"
        src="https://player.vimeo.com/video/648049237?h=f13d39e90d"
        width="640"
        height="320"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      ></iframe>
    </div>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/onboard/PageLayout.vue"

const FB_REDIRECT_URL = window.location.origin + "/onboard/connect/facebook"
const NEXT_ROUTE = "/onboard/connect/business-manager"

export default {
  name: "FacebookAccount",
  components: {
    PageLayout,
  },
  computed: {
    ...get("app", ["apiResponseState"]),
    ...get("auth", ["fbLoginPending"]),
  },
  methods: {
    ...call("app", ["resetApiResponseState"]),
    ...call("auth", ["getFacebookLogin", "connectWithFacebook"]),

    redirectToFacebook() {
      this.getFacebookLogin(FB_REDIRECT_URL).then(response => {
        if (response && response.loginUrl) {
          window.location.href = response.loginUrl
        }
      })
    },
  },
  mounted() {
    this.resetApiResponseState()

    // returned from FB login
    if (this.$router.currentRoute.query.code) {
      this.connectWithFacebook({
        code: this.$router.currentRoute.query.code,
        redirectUrl: FB_REDIRECT_URL,
      }).then(() => {
        this.$router.push(NEXT_ROUTE)
      })
    }
  },
}
</script>
